const header = document.querySelector('.js-site-header');
const modules = document.querySelectorAll('.js-site-content > *');
const floatingPageNavItems = document.querySelectorAll('.js-module-page-nav-fixed-item');

let prevYPosition = 0;
let direction = 'up';

const setScrollDirection = () => {
    direction = window.scrollY === 0 || window.scrollY > prevYPosition ? 'down' : 'up';
    prevYPosition = window.scrollY
}

const getTargetModule = (target) => {
    if (direction === 'up') return target;

    if (target.nextElementSibling) {
        return target.nextElementSibling
    } else {
        return target
    }
}

const shouldUpdate = (entry) => {
    if (direction === 'down' && !entry.isIntersecting) {
        return true;
    }

    return direction === 'up' && entry.isIntersecting;
}

const bfObserver = item => {
    const offsetTop = (item.getBoundingClientRect().top) * -1;
    const offsetBottom = (window.innerHeight + offsetTop - item.offsetHeight) * -1;
    const options = {
        rootMargin: `${offsetTop}px 0px ${offsetBottom}px 0px`,
        threshold: 0,
    };
    const onIntersect = (entries) => {
        setScrollDirection();

        entries.forEach((entry) => {
            const target = getTargetModule(entry.target)

            if (shouldUpdate(entry)) {
                item.classList.toggle('dark', target.classList.contains('dark'));
            }
        });
    };
    const observer = new IntersectionObserver(onIntersect, options);

    modules.forEach(module => {
        observer.observe(module);
    });
}

if (floatingPageNavItems.length > 0) {
    floatingPageNavItems.forEach(item => {
        bfObserver(item);
    });
}
